module.exports = __webpack_public_path__ + "media/events/RoadShow2018-6fa24632.png";